// This file configures the initialization of Sentry on the client.
// It will be automatically picked up by Next.js (App Router) if named instrumentation-client.ts
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"APP_ID: ee52616e-cc47-4797-9612-8431f1edd354 V: 1.137.17"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:slug*?\",\"regex\":\"^/(?:/(.*))?$\",\"paramNames\":[\"slug\"]}],\"staticRoutes\":[{\"path\":\"/get-test-error\"}]}";import * as Sentry from "@sentry/nextjs";

import packageJson from "../package.json";

const DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
const APP_ID = process.env.NEXT_PUBLIC_APP_ID;
const CONFIG_ID = process.env.NEXT_PUBLIC_CONFIG_ID;
const ENVIRONMENT = process.env.ENV;

if (process.env.NODE_ENV !== "development") {
  if (!DSN || !APP_ID || !CONFIG_ID) {
    console.warn("[Sentry] Missing env variables:", {
      DSN,
      APP_ID,
      CONFIG_ID,
    });
  } else {
    Sentry.init({
      dsn: DSN,
      // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
      tracesSampleRate: 1,
      // Setting this option to true will print useful information to the console while you're setting up Sentry.
      debug: false,
      // Set release to match the uploaded source maps
      release: `APP_ID: ${APP_ID} V: ${packageJson.version}`,
      // Set dist to distinguish between different builds/environments
      dist: ENVIRONMENT,
    });

    Sentry.setTag("app_id", APP_ID);
    Sentry.setTag("config_id", CONFIG_ID);
  }
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
